module.exports = __webpack_public_path__ + "img/traveller-nosignal.4d5d1b9d.svg";